import axios from '../util/Api.js';

export const getLocationData = async (evse_data) => {
  const connector_data = evse_data.connectors?.[0];
  delete evse_data.connectors;

  const location_data = (await axios.get(`locations/${evse_data.location_id}`))
    .data;
  const operator = location_data.operator?.name;
  delete location_data.operator;
  // const operator_data = (await axios.get(`operators/${location_data.operator_id}`)).data;
  let raw_tariff;
  if (connector_data.tariff_id) {
    raw_tariff = (await axios.get(`tariffs/${connector_data.tariff_id}`)).data;
  } else {
    raw_tariff = (await axios.get(`tariffs/station/${evse_data.station_id}`)).data;
  }
  const tariff_data = {
    price_kwh: raw_tariff.pricePerKwh,
    price_minute: raw_tariff.pricePerMin,
    price_min: raw_tariff.pricePerMin,
    price_session: raw_tariff.pricePerSession,
    idle_per_min: raw_tariff.idlePerMin,
    idle_per_hour: raw_tariff.idlePerHour,
    idle_start_hour: raw_tariff.idleStartHour,
    idle_grace_min: raw_tariff.idleGraceMin,
    max_daily_tariff: raw_tariff.maxDailyTariff,
    max_session_tariff: raw_tariff.maxSessionTariff,
    idle_timezone: raw_tariff.idleTimezone,
    currency: raw_tariff.currency,
    tax_rate: raw_tariff.taxRate,
    tax_included: raw_tariff.taxIncluded === true,
    authorization_amount: raw_tariff.authorizationAmount,
    payment_fee: raw_tariff.paymentFee,
  };

  return {
    ...evse_data,
    ...connector_data,
    ...location_data,
    operator,
    station_name: raw_tariff.stationName,
    payment_terms_conditions: raw_tariff.termsConditions || location_data.payment_terms_conditions,
    terms_version: raw_tariff.termsVersion,
    tariff_data,
  };
};
